import {
  Button,
  Card,
  Col,
  Form,
  Input,
  Modal,
  Row,
  Space,
  Switch,
  Table,
} from "antd";
import type { ColumnsType } from "antd/es/table";

import {
  DeleteOutlined,
  SearchOutlined,
  EditFilled,
  EyeOutlined,
} from "@ant-design/icons";
import { useLocation, useNavigate } from "react-router-dom";
import {
  LazyLoadImage,
  ScrollPosition,
  trackWindowScroll,
} from "react-lazy-load-image-component";
import "react-lazy-load-image-component/src/effects/blur.css";
import {
  useLazyGetCategoryQuery,
  useDeleteLoanTypeMutation,
  usePutUpdateCategoryMutation,
} from "../../../services/category";
import { useEffect, useLayoutEffect, useState } from "react";
import { errorToast, successToast } from "../../../helpers";
import { CommonBody, category } from "../../../types/General";
import { generateEncryptedKeyBody } from "../../../utils/crypto";
import useAuth from "../../../hooks/useAuth";

const { confirm } = Modal;

type PropTypes = {
  scrollPosition?: ScrollPosition;
};

const ProductCategoryList = ({ scrollPosition }: PropTypes) => {
  const userData = useAuth();
  const { state } = useLocation();
  console.log(state);

  const [getCategory] = useLazyGetCategoryQuery();
  const [deleteCategory] = useDeleteLoanTypeMutation();
  const [updateCategory] = usePutUpdateCategoryMutation();
  const [allCategoryData, setAllCategoryData] = useState<category[]>();
  const [currentPage, setCurrentPage] = useState<number>(state?.page || 1);
  console.log(currentPage);
  const [totalCount, setTotalCount] = useState<number | undefined>(0);
  const [query, setQuery] = useState("");
  const [debouncedQuery, setDebouncedQuery] = useState("");
  const [loading, setLoading] = useState(false);
  const navigate = useNavigate();
  const [hidePermission, setHidePermission] = useState<any>({
    isAdd: true,
    isDelete: true,
  });
  // useLayoutEffect(() => {
  //   setCurrentPage(state?.page || 1);
  // }, []);
  useEffect(() => {
    navigate("/product-categories", { replace: true, state: null });
  }, []);
  const getCategoryDetails = async (page: number) => {
    try {
      setLoading(true);
      const res = await getCategory({
        page: currentPage,
        size: 10,
        search: query || "",
      }).unwrap();
      setLoading(false);

      if (res?.statusCode === 200) {
        setAllCategoryData(res?.data?.category);
        setTotalCount(res?.data?.count);
        console.log(totalCount);
      }
    } catch (error: any) {
      setLoading(false);
      console.log(error);
    }
  };

  const activeInactiveCategory = async (isBlocked: boolean, _id: string) => {
    console.log(isBlocked, "isActive");

    const data = {
      isBlocked: isBlocked,
    };

    try {
      let encryptedBody = generateEncryptedKeyBody(data) as CommonBody;

      const res = await updateCategory({
        encryptedBody,
        categoryId: _id,
      }).unwrap();
      if (res?.statusCode === 200) {
        successToast(
          isBlocked
            ? "Category Deactivated Successfully!"
            : "Category Activated Successfully!"
        );
        getCategoryDetails(1);
      }
    } catch (error: any) {
      console.log(error);
      errorToast(error?.data?.message);
    }
  };
  const enableDisableFeaturedCategory = async (
    isFeatured: boolean,
    _id: string
  ) => {
    const data = {
      isFeatured: isFeatured,
    };

    try {
      let encryptedBody = generateEncryptedKeyBody(data) as CommonBody;

      const res = await updateCategory({
        encryptedBody,
        categoryId: _id,
      }).unwrap();
      if (res?.statusCode === 200) {
        successToast(
          isFeatured
            ? "Removed from featured category!"
            : "Added to featured category!"
        );
        getCategoryDetails(1);
      }
    } catch (error: any) {
      console.log(error);
      errorToast(error?.data?.message);
    }
  };
  const handleDelete = async (id: string) => {
    try {
      const res = await deleteCategory({ categoryId: id }).unwrap();

      if (res?.statusCode === 200) {
        successToast("Category deleted successfully");
        getCategoryDetails(1);
      }
    } catch (error: any) {
      console.log(error);
      errorToast(error?.data?.message);
    }
  };

  const showDeleteConfirm = (record: any) => {
    confirm({
      title: "Hold on",
      content: "Are you sure delete this category?",
      okText: "Yes",
      okType: "danger",
      cancelText: "No",
      onOk() {
        handleDelete(record?._id);
        console.log("OK");
      },
      onCancel() {
        console.log("Cancel");
      },
    });
  };

  const checkPermission = () => {
    const permissions = userData?.permissions;
    if (permissions?.length) {
      let idx = -1;
      idx = permissions?.findIndex(
        (ele: any) => ele?.label === "Product Categories"
      );

      if (idx != -1) {
        let data = {
          isAdd: permissions[idx]?.isAdd,
          isDelete: permissions[idx]?.isDelete,
        };
        setHidePermission(data);
      }
    }
  };

  useEffect(() => {
    if (userData && userData?.permissions?.length) {
      checkPermission();
    }
  }, [userData]);

  const columns: ColumnsType<category> = [
    {
      title: "Image",
      dataIndex: "image",
      key: "image",
      align: "center",
      render: (_, { image }) => (
        <div>
          {image ? (
            <LazyLoadImage
              alt="img"
              style={{ width: 40, height: 40, borderRadius: 50 }}
              src={image}
              effect="blur"
              scrollPosition={scrollPosition}
            />
          ) : (
            "N/A"
          )}
        </div>
      ),
    },

    {
      title: "Name",
      dataIndex: "name",
      key: "name",
      align: "center",
    },

    {
      title: "Action",
      key: "action",
      align: "center",
      render: (_, record) => (
        <Space size="middle">
          <Button
            onClick={(e) => {
              e.preventDefault();
              navigate(`/product-categories/sub-category/${record?._id}`, {
                state: {
                  page: currentPage,
                },
              });
            }}
          >
            <EyeOutlined style={{ color: "#52c41a" }} />
          </Button>
          {hidePermission?.isAdd ? (
            <Button
              onClick={(e) => {
                e.preventDefault();
                navigate(`/product-categories/${record?._id}`, {
                  state: {
                    page: currentPage,
                  },
                });
              }}
            >
              <EditFilled style={{ color: "#C69320" }} />
            </Button>
          ) : (
            ""
          )}
          {hidePermission?.isDelete ? (
            <Button
              onClick={(e) => {
                e.preventDefault();
                showDeleteConfirm(record);
              }}
            >
              <DeleteOutlined style={{ color: "#d4380d" }} />
            </Button>
          ) : (
            ""
          )}
        </Space>
      ),
    },
    {
      title: "Featured",
      dataIndex: "featured",
      key: "isFeatured",
      align: "center",
      render: (_, { isFeatured, _id }: any) => (
        <Switch
          size="small"
          checked={isFeatured}
          onChange={() => enableDisableFeaturedCategory(!isFeatured, _id)}
        />
      ),
    },
    {
      title: "Status",
      dataIndex: "status",
      key: "deviation",
      align: "center",
      render: (_, { isBlocked, _id }: any) => (
        <Switch
          size="small"
          checked={!isBlocked}
          onChange={() => activeInactiveCategory(!isBlocked, _id)}
        />
      ),
    },
  ];

  // useEffect(() => {
  //   getCategoryDetails(1);
  // }, [query, currentPage]);
  useEffect(() => {
    getCategoryDetails(currentPage);
  }, [query, currentPage]);
  const handlePageChange = (page: number) => {
    setCurrentPage(page);
    getCategoryDetails(page);
  };

  const pagination = {
    pageSize: 10,
    current: currentPage,
    total: totalCount,
    onChange: handlePageChange,
  };

  useEffect(() => {
    const delay = 1000;
    const timerId = setTimeout(() => {
      setQuery(debouncedQuery);
    }, delay);
    return () => {
      clearTimeout(timerId);
    };
  }, [debouncedQuery]);

  return (
    <div>
      <div className="srch">
        <Card style={{ overflowX: "scroll" }}>
          <Row
            style={{ justifyContent: "space-between", padding: "10px 0px" }}
            gutter={16}
          >
            <Col xs={24} md={7}>
              <Form
                style={{ display: "flex", gap: 20 }}
                onFinish={() => getCategoryDetails(1)}
              >
                <Input
                  placeholder="Search Category"
                  prefix={<SearchOutlined style={{ fontSize: "24px" }} />}
                  style={{ height: 50, borderRadius: 10 }}
                  value={debouncedQuery}
                  onChange={(e) => setDebouncedQuery(e.target.value)}
                  maxLength={20}
                  allowClear
                />
              </Form>
            </Col>
            <Col
              style={{
                margin: 1,
                display: "flex",
                alignItems: "center",
                justifyContent: "space-between",
              }}
            >
              <Button
                style={{
                  background: "#ECAC35",
                  height: 35,
                  color: "black",
                }}
                type="primary"
                onClick={(e) => {
                  e.preventDefault();
                  navigate(`/product-categories/add`);
                }}
              >
                Add Category
              </Button>
            </Col>
          </Row>
          <Table
            columns={columns}
            dataSource={allCategoryData}
            pagination={pagination}
            loading={loading}
            rowKey="_id"
          />
        </Card>
      </div>
    </div>
  );
};

export default trackWindowScroll(ProductCategoryList);
